<template>
  <div class="error-page">
    <main class="mc-panel">
      <h1>404</h1>
      <p>There is no page at {{ $route.path }}.</p>
      <div class="buttons">
        <button class="button" @click="back">
          Back
        </button>
        <router-link class="button button-primary" :to="{ name: 'home' }">
          Home
        </router-link>
      </div>
    </main>
  </div>
</template>

<script>
// Like the wargame platform's error page.
export default {
    name: 'NotFoundView',
    methods: {
        back () {
            if (window.history.length > 1) this.$router.back()
            else this.$router.push({ name: 'home' })
        },
    },
}
</script>

<style lang="scss" scoped>
.error-page {
    display: grid;
    place-items: center;
    min-height: 60vh;
    text-align: center;
}

main {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: min(32rem, 100%);
}

h1 {
    margin-bottom: 1rem;
    font-size: 3.375rem;
}

p {
    overflow-wrap: anywhere;
}

.buttons {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    width: min(20rem, 100%);
    margin-top: 1rem;
}
</style>
